// Use this for any shared settings that cross environment bounds.
// TODO: Setup explicit permissions if applicable to your Frontend web application.
// See https://gitlab.com/ZonarSystems/tools/pattern-library/-/tree/master/projects/zonar-ui-auth#Permissions for details

export const AUTH_PERMISSIONS = {
  MANAGE_ALERTS: 'manage:alerts',
  VIEW_ALERTS: 'view:alerts',
};

export const permissions = {
  defaultRedirectUrl: '/no-permission',
  defaultPermPrefix: 'gtcx_am',
  routes: [
    ['add', AUTH_PERMISSIONS.MANAGE_ALERTS],
    ['edit/:id', AUTH_PERMISSIONS.MANAGE_ALERTS],
    ['clone/:id', AUTH_PERMISSIONS.MANAGE_ALERTS],
    ['/', AUTH_PERMISSIONS.VIEW_ALERTS],
    ['myalerts', AUTH_PERMISSIONS.VIEW_ALERTS],
  ]
};
//TODO: change appName (should match datadog app name)
export const appName = 'alert-management';
// Typically we would use this to report to Datadog RUM if we have it installed.
export const appVersion = '0.0.1';

export const httpRetryCount = 3;
